import { memberships, voices } from "@/mocks/chigua";
import SectionHeading from "./SectionHeading";

function About() {
  return (
    <section id="about" className="relative py-16 md:py-24">
      <div className="container-x">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="sticky top-24">
              <SectionHeading
                eyebrow="关于黑屋"
                title="一家把「吃瓜」当手艺的编辑团队"
                desc="吃瓜黑屋诞生于 2021 年，是一个只写娱乐与大众热点背后逻辑的独立观察栏目。"
              />
              <div className="mt-6 space-y-4 text-[15px] leading-relaxed text-foreground-400">
                <p>
                  起初我们只是几位在影视、媒体与数据研究一线工作的朋友，因为厌倦了情绪化的八卦与千篇一律的热搜搬运，决定把「吃瓜」这件事做得更负责任一些。
                </p>
                <p>
                  于是有了吃瓜黑屋：一篇稿子反复核实、一个细节追到源头、一句没把握的话宁可标注待核实也不写死。我们相信，热点会过期，但把事情讲透的能力不会。
                </p>
                <p>
                  几年下来，我们从图文延伸到深度专题与读者社群，慢慢把「把瓜看透」做成了不少读者睡前必读的习惯。
                </p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 gap-5 sm:grid-cols-3">
              {memberships.map((m, i) => (
                <div
                  key={m.title}
                  className="rounded-2xl border border-background-800 bg-background-900/70 p-6 transition-colors hover:border-accent-500/30"
                >
                  <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500/15 text-primary-300">
                    <i className={["ri-team-line", "ri-shield-check-line", "ri-compass-3-line"][i]} aria-hidden="true"></i>
                  </span>
                  <h3 className="mt-5 font-serif text-lg font-bold text-foreground-100">{m.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-500">{m.desc}</p>
                </div>
              ))}
            </div>

            <div className="mt-5 rounded-2xl border border-background-800 bg-background-950/60 p-6 md:p-8">
              <div className="flex items-center justify-between">
                <h3 className="font-serif text-xl font-bold text-foreground-50">读者怎么说</h3>
                <span className="flex items-center gap-1 text-secondary-300">
                  <i className="ri-star-fill" aria-hidden="true"></i>
                  <i className="ri-star-fill" aria-hidden="true"></i>
                  <i className="ri-star-fill" aria-hidden="true"></i>
                  <i className="ri-star-fill" aria-hidden="true"></i>
                  <i className="ri-star-fill" aria-hidden="true"></i>
                </span>
              </div>
              <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
                {voices.map((v) => (
                  <figure
                    key={v.name}
                    className="rounded-xl border border-background-800 bg-background-900/60 p-5"
                  >
                    <i className="ri-double-quotes-l text-2xl text-primary-500/40" aria-hidden="true"></i>
                    <blockquote className="mt-2 text-sm leading-relaxed text-foreground-300">“{v.text}”</blockquote>
                    <figcaption className="mt-4 flex items-center gap-2.5">
                      <span className="flex h-8 w-8 items-center justify-center rounded-full bg-secondary-500/20 text-xs font-bold text-secondary-300">
                        {v.name.slice(0, 1)}
                      </span>
                      <div>
                        <p className="text-sm font-medium text-foreground-100">{v.name}</p>
                        <p className="text-xs text-foreground-500">{v.role}</p>
                      </div>
                    </figcaption>
                  </figure>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;